import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import api from 'services';
import moment from 'moment';
import { RaisedButton, DatePicker, Table, TableBody, TableHeaderColumn, TableRow, TableRowColumn, TableHeader } from 'material-ui';
import styles from 'styles';
import Info from './Info/index';
import Charts from './Charts/index';

class StatisticsStPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            users: [],
            currentUser: {},
            fromMin: moment([2018, 5, 5]).toDate(),
            fromMax: moment().toDate(),

            untilMin: moment([2018, 5, 5]).toDate(),
            untilMax: moment().add('years', 2).toDate(),

            from: moment().subtract(1, 'months').toDate(),
            until: moment().toDate(),
        };

        this.changeFrom = this.changeFrom.bind(this);
        this.changeUntil = this.changeUntil.bind(this);

        this.countRequests = this.countRequests.bind(this);
        this.showCurrent = this.showCurrent.bind(this);
    }

    async componentDidMount() {
        const { from, until } = this.state;

        const response = await api.getStatisticsSt({ from: from.getTime(), until: until.getTime() });
        if (response.status === 200) {
            return this.setState({
                users: response.data,
                currentUser: {},
            });
        }

        return null;
    }

    changeFrom(e, date) {
        this.setState({
            from: date,
            untilMin: date,
        }, async () => {
            const { from, until } = this.state;

            const response = await api.getStatisticsSt({ from: from.getTime(), until: until.getTime() });
            if (response.status === 200) {
                return this.setState({
                    users: response.data,
                    currentUser: {},
                });
            }
        });
    }

    changeUntil(e, date) {
        this.setState({
            until: date,
            fromMax: date,
        }, async () => {
            const { from, until } = this.state;

            const response = await api.getStatisticsSt({ from: from.getTime(), until: until.getTime() });
            if (response.status === 200) {
                return this.setState({
                    users: response.data,
                    currentUser: {},
                });
            }
        });
    }

    showCurrent(currentUser) {
        this.setState({
            currentUser,
        });
    }

    countRequests(array, type) {
        return array.reduce((accumulator, currentValue) => (currentValue.type === type ? accumulator + 1 : accumulator), 0);
    }

    render() {
        const {
            until, untilMin, untilMax, from, fromMin, fromMax, users, currentUser, 
        } = this.state;

        return (
            <div id='statistics-st' className='container'>
                <h3>Statistics st</h3>

                <div className='paper-block margin-10'>
                    <div className='row'>
                        <div className='col-xs-2 middle-xs' style={{ display: 'flex' }}>
                            <DatePicker
                                floatingLabelText='From'
                                minDate={fromMin}
                                maxDate={fromMax}
                                onChange={this.changeFrom}
                                value={from}
                                autoOk
                                fullWidth
                                formatDate={date => moment(date).format('DD-MM-YYYY')}
                            />
                        </div>
                        <div className='col-xs-2 middle-xs' style={{ display: 'flex' }}>
                            <DatePicker
                                floatingLabelText='Until'
                                minDate={untilMin}
                                maxDate={untilMax}
                                onChange={this.changeUntil}
                                value={until}
                                autoOk
                                fullWidth
                                formatDate={date => moment(date).format('DD-MM-YYYY')}
                            />
                        </div>
                    </div>
                </div>
                <Table selectable={false}>
                    <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                        <TableRow>
                            <TableHeaderColumn style={styles.tableHeaderColumnCSS}>
                                email
                            </TableHeaderColumn>
                            <TableHeaderColumn style={styles.tableHeaderColumnCSS}>
                                name
                            </TableHeaderColumn>
                            <TableHeaderColumn style={styles.tableHeaderColumnCSS}>
                                request(cargo)
                            </TableHeaderColumn>
                            <TableHeaderColumn style={styles.tableHeaderColumnCSS}>
                                request(vessel)
                            </TableHeaderColumn>
                            <TableHeaderColumn style={styles.tableHeaderColumnCSS}>
                                request(tc)
                            </TableHeaderColumn>
                            <TableHeaderColumn style={styles.tableHeaderColumnCSS}>
                                gazetter
                            </TableHeaderColumn>
                            <TableHeaderColumn style={styles.tableHeaderColumnCSS}>
                                {null}
                            </TableHeaderColumn>
                        </TableRow>
                    </TableHeader>

                    <TableBody displayRowCheckbox={false}>
                        {
                            users.map((user, index) => (
                                <TableRow key={index}>
                                    <TableRowColumn style={styles.tableRowColumnCSS}>
                                        { user.user.email }
                                    </TableRowColumn>
                                    <TableRowColumn style={styles.tableRowColumnCSS}>
                                        { user.user.name }
                                    </TableRowColumn>
                                    <TableRowColumn style={styles.tableRowColumnCSS}>
                                        { this.countRequests(user.addRequest, 'cargo') }
                                    </TableRowColumn>
                                    <TableRowColumn style={styles.tableRowColumnCSS}>
                                        { this.countRequests(user.addRequest, 'vessel') }
                                    </TableRowColumn>
                                    <TableRowColumn style={styles.tableRowColumnCSS}>
                                        { this.countRequests(user.addRequest, 'tc') }
                                    </TableRowColumn>
                                    <TableRowColumn style={styles.tableRowColumnCSS}>
                                        { user.addGazeteer.length }
                                    </TableRowColumn>
                                    <TableRowColumn style={styles.tableRowColumnCSS}>
                                        <RaisedButton
                                            onClick={() => { this.showCurrent(user); }}
                                            label='details'
                                        />
                                    </TableRowColumn>
                                </TableRow>
                            ))
                        }
                    </TableBody>
                </Table>

                <Info
                    current={currentUser}
                    from={from}
                    until={until}
                />


                <Charts
                    current={currentUser}
                    from={from}
                    until={until}
                />

            </div>
        );
    }
}

export default connect(
    (state, props) => ({

    }),
    dispatch => bindActionCreators({}, dispatch),
)(StatisticsStPage);



// WEBPACK FOOTER //
// ./app/components/Statistics/St/Page.jsx